import * as React from 'react';
export const bethpageSvg = React.forwardRef(function bethpageSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#007A82',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.607 21.108c0-5.478 4.183-10.251 7.618-10.251 1.136 0 1.823.607 1.823 1.488 0 1.709-2.598 3.62-3.805 4.43-.229.159-.502.317-.502.564 0 .29.291.44.846.484 1.973.185 3.708.758 3.708 1.938s-1.251 1.928-4.774 2.272c-2.65.255-4.007.73-4.747 1.013-.061-.291-.158-.916-.158-1.93m-2.607-1.91c0 4.65 2.105 7.363 2.563 7.794 1.92-1.013 3.663-1.339 7.336-1.955 5.09-.846 7.495-2.281 7.495-4.703 0-2.695-3.787-3.858-6.658-4.016-.23-.009-.414-.106-.414-.282 0-.14.14-.229.282-.335 2.598-1.902 5.407-4.614 5.407-7.574C23.02 6.691 22.113 5 19.365 5 13.922 5 7 11.79 7 19.197',
      fill: '#FAAE24',
    }),
  );
});
bethpageSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bethpage = {
  category: 'brand',
  colorable: false,
  name: 'bethpage',
  svg: bethpageSvg,
};
